var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13618",
    "data-name": "Group 13618",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.678,
    height: 101.669,
    viewBox: "0 0 101.678 101.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3540",
    "data-name": "Rectangle 3540",
    width: 101.678,
    height: 101.669,
    fill: "#006341"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13617",
    "data-name": "Group 13617",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53089",
    "data-name": "Path 53089",
    d: "M0,94.321a10.09,10.09,0,0,1,3.014-4.546Q16.7,76.156,30.334,62.482c2.444-2.443,4.5-2.616,7.253-.639l6.068-6.092C36.347,47.26,33.5,37.429,35.793,26.329A32,32,0,0,1,48.745,6.421a33.306,33.306,0,1,1-2.756,51.658l-6.093,6.1c1.911,2.7,1.745,4.713-.7,7.162Q25.574,84.959,11.964,98.586a10.308,10.308,0,0,1-4.616,3.083H5.164c-.606-.242-1.232-.443-1.813-.735A6.751,6.751,0,0,1,0,96.506Zm37.99-60.96A30.357,30.357,0,1,0,68.265,2.977,30.455,30.455,0,0,0,37.99,33.362M28.333,68.723c-.136.124-.262.229-.377.344Q16.066,80.953,4.18,92.842a5.653,5.653,0,0,0-.532.588,3.256,3.256,0,0,0,1.6,5.083A3.385,3.385,0,0,0,8.91,97.419Q20.649,85.662,32.4,73.921c.2-.2.377-.427.527-.6l-4.6-4.6m6.949,2.369c.791-.814,1.676-1.652,2.471-2.568a1.572,1.572,0,0,0-.054-2.247c-.733-.805-1.507-1.577-2.312-2.311a1.6,1.6,0,0,0-2.249-.045c-.907.807-1.756,1.677-2.568,2.461l4.712,4.709",
    transform: "translate(0 0)",
    fill: "#006341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53090",
    "data-name": "Path 53090",
    d: "M210.259,23.7a27,27,0,0,1,26.81,24.684,26.407,26.407,0,0,1-5.289,18.541c-.728.988-1.605,1.177-2.358.552-.7-.585-.715-1.394.008-2.37a24.358,24.358,0,0,0,4.306-9.6,23.971,23.971,0,0,0-37.726-24.044,2.288,2.288,0,0,1-1.4.583,2.168,2.168,0,0,1-1.323-.961c-.388-.653-.008-1.279.564-1.718a25.14,25.14,0,0,1,7.469-4.029,32.505,32.505,0,0,1,4.307-1.127c1.524-.275,3.083-.351,4.627-.514",
    transform: "translate(-141.903 -17.412)",
    fill: "#006341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53091",
    "data-name": "Path 53091",
    d: "M183.032,105.309a26.913,26.913,0,0,1-26.773-24.136,26.205,26.205,0,0,1,5.188-18.954c.734-.993,1.587-1.243,2.34-.707s.8,1.458.078,2.439a23.952,23.952,0,0,0,33.557,33.515,1.627,1.627,0,0,1,2.167-.166,1.505,1.505,0,0,1-.231,2.448,26.309,26.309,0,0,1-12.478,5.214c-1.275.175-2.565.236-3.849.349",
    transform: "translate(-114.686 -44.992)",
    fill: "#006341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53092",
    "data-name": "Path 53092",
    d: "M231.592,149.99a12.6,12.6,0,0,1,8.619,3.286c.937.849,1.059,1.685.388,2.4-.621.663-1.484.6-2.362-.165a10.032,10.032,0,0,0-13.322-.022c-.917.795-1.833.847-2.432.138-.573-.678-.43-1.57.425-2.341a13.041,13.041,0,0,1,8.685-3.3",
    transform: "translate(-163.215 -110.204)",
    fill: "#006341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53093",
    "data-name": "Path 53093",
    d: "M274.756,92.751c.81-.864,1.42-1.561,2.08-2.205a1.451,1.451,0,0,1,2.2-.108,1.47,1.47,0,0,1-.106,2.2c-.314.34-.645.665-.981.984s-.683.615-1.212,1.089c.795.71,1.515,1.294,2.164,1.949a1.456,1.456,0,0,1,.16,2.2,1.511,1.511,0,0,1-2.275-.127c-.635-.624-1.216-1.3-2.062-2.222-.686.812-1.227,1.521-1.84,2.16a1.5,1.5,0,1,1-2.078-2.095c.609-.6,1.262-1.158,2.043-1.869-.779-.74-1.431-1.332-2.051-1.957a1.552,1.552,0,0,1-.251-2.276c.651-.7,1.514-.661,2.34.171.626.631,1.186,1.328,1.873,2.1",
    transform: "translate(-198.493 -66.116)",
    fill: "#006341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53094",
    "data-name": "Path 53094",
    d: "M216.717,94.648c.857.8,1.559,1.4,2.2,2.066a1.459,1.459,0,0,1,.117,2.129,1.519,1.519,0,0,1-2.21-.035c-.344-.309-.67-.64-.983-.98s-.6-.7-1.149-1.355c-.692.83-1.223,1.543-1.834,2.18a1.5,1.5,0,1,1-2.1-2.076c.607-.605,1.255-1.168,2.119-1.967-.553-.451-1.008-.768-1.4-1.151-1.48-1.453-1.715-2.275-.914-3.047s1.516-.569,3.037.981a16.669,16.669,0,0,1,1.076,1.367c.839-.883,1.452-1.569,2.109-2.211a1.452,1.452,0,0,1,2.195-.136,1.491,1.491,0,0,1-.075,2.206c-.312.342-.641.669-.98.984s-.7.606-1.211,1.045",
    transform: "translate(-154.379 -66.105)",
    fill: "#006341"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.dc91c8078e426a40f17e20e8a73b98e2.svg";
export { ForwardRef as ReactComponent };